import './_submenu-links.scss';
import component from './submenu-links';

export default component;
